'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _modal = require('../../redux/modules/modal');

var _user = require('../../redux/modules/user');

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var loginModalOpen = openModal === 'LOGIN';
    var userDataLoading = (0, _user.isUserDataLoading)(state);

    return {
        loginModalOpen: loginModalOpen,
        userDataLoading: userDataLoading,
        userLoggedIn: userLoggedIn
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        openLoginModal: _modal.openLoginModal,
        push: _reactRouterRedux.push
    }, dispatch);
};

var EnsureLoggedInContainer = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(EnsureLoggedInContainer, _React$Component);

    function EnsureLoggedInContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, EnsureLoggedInContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnsureLoggedInContainer.__proto__ || (0, _getPrototypeOf2.default)(EnsureLoggedInContainer)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (nextProps) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(EnsureLoggedInContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.timeout = setTimeout(function () {
                if (!_this2.props.userLoggedIn && !_this2.props.userDataLoading) {
                    _this2.props.openLoginModal();
                }
            }, 1000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timeout);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                loginModalOpen = _props.loginModalOpen,
                openLoginModal = _props.openLoginModal,
                push = _props.push,
                userDataLoading = _props.userDataLoading,
                userLoggedIn = _props.userLoggedIn;
            var wasOpenLoginModal = prevProps.openLoginModal,
                wasUserLoggedIn = prevProps.userLoggedIn;


            if (userDataLoading) {
                return;
            }

            if (wasOpenLoginModal && !loginModalOpen && !userLoggedIn && !userDataLoading || !loginModalOpen && !userLoggedIn && wasUserLoggedIn) {
                return push({ pathname: '/' });
            }

            if (!loginModalOpen && !userLoggedIn && !wasUserLoggedIn && !userDataLoading) {
                return openLoginModal();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.userLoggedIn ? this.props.children : null;
        }
    }]);
    return EnsureLoggedInContainer;
}(React.Component), _class.defaultProps = {
    loginModalOpen: false
}, _temp2);
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EnsureLoggedInContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EnsureLoggedIn/EnsureLoggedInContainer.js
// module id = OylW
// module chunks = 60